/* ===========================================================
   HEADER TRANSITION — Dragon d'Airain
   Technique FLIP pour animer logo entre la rangée haute
   (pleine largeur centrée) et la rangée condensée (gauche).
   =========================================================== */
(function () {
  'use strict';

  var EASE    = 'cubic-bezier(.22,.61,.36,1)';
  var DURATION = 420; // ms

  var wrapper    = document.querySelector('[data-wetheme-section-type="header"]');
  var header     = document.querySelector('.site-header');
  if (!header || !wrapper) return;

  var logoWrap   = header.querySelector('.site-header__wrapper__center');
  var navRow     = header.querySelector('.site-header__wrapper__left');
  var iconsRow   = header.querySelector('.site-header__wrapper__right');
  if (!logoWrap) return;

  /* ---- Capture de la position courante du logo ---- */
  var prevRect = logoWrap.getBoundingClientRect();
  var rafCapture = null;

  function scheduleCapture() {
    if (rafCapture) return;
    rafCapture = requestAnimationFrame(function () {
      rafCapture = null;
      if (!wrapper.classList.contains('sticked')) {
        prevRect = logoWrap.getBoundingClientRect();
      }
    });
  }

  /* Capture pendant le scroll (avant que sticked change) */
  window.addEventListener('scroll', scheduleCapture, { passive: true });

  /* ---- Animation FLIP ---- */
  var animating = false;

  function flip(fromRect) {
    var toRect = logoWrap.getBoundingClientRect();

    var dx = fromRect.left   - toRect.left;
    var dy = fromRect.top    - toRect.top;
    var sx = fromRect.width  / Math.max(toRect.width,  1);
    var sy = fromRect.height / Math.max(toRect.height, 1);

    /* Pas de mouvement → skip */
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1 &&
        Math.abs(sx - 1) < 0.02 && Math.abs(sy - 1) < 0.02) return;

    animating = true;

    /* Invert : repositionne visuellement le logo à son ancienne place */
    logoWrap.style.transition   = 'none';
    logoWrap.style.transformOrigin = 'left top';
    logoWrap.style.transform    = 'translate(' + dx + 'px,' + dy + 'px)' +
                                  ' scale(' + sx.toFixed(4) + ',' + sy.toFixed(4) + ')';

    /* Play : anime vers la nouvelle position (identity transform) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        logoWrap.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
        logoWrap.style.transform  = '';
      });
    });

    /* Nettoyage après la fin */
    var tid = setTimeout(cleanup, DURATION + 50);
    logoWrap.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'transform') return;
      clearTimeout(tid);
      logoWrap.removeEventListener('transitionend', onEnd);
      cleanup();
    });
  }

  function cleanup() {
    animating = false;
    logoWrap.style.transition    = '';
    logoWrap.style.transform     = '';
    logoWrap.style.transformOrigin = '';
  }

  /* ---- Transitions CSS sur la séparation et l'espacement ---- */
  function applyRowTransitions() {
    var t = DURATION + 'ms ' + EASE;
    if (navRow)   navRow.style.transition   = 'border-top-color ' + t + ', padding ' + t;
    if (iconsRow) iconsRow.style.transition = 'border-top-color ' + t;
  }
  applyRowTransitions();

  /* ---- Observation du changement de classe sticked ---- */
  var wasSticked = wrapper.classList.contains('sticked');

  var observer = new MutationObserver(function () {
    var isSticked = wrapper.classList.contains('sticked');
    if (isSticked === wasSticked || animating) return;

    var fromRect = prevRect;        /* position capturée avant le changement */
    wasSticked = isSticked;

    /* Quand on revient à l'état non-sticked, capturer depuis sticked */
    if (!isSticked) {
      fromRect = logoWrap.getBoundingClientRect();
    }

    requestAnimationFrame(function () {
      flip(fromRect);
      /* Mise à jour pour le prochain cycle */
      prevRect = logoWrap.getBoundingClientRect();
    });
  });

  observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
})();

/* ===========================================================
   GIF LOGO — joue une fois au hover
   =========================================================== */
(function () {
  'use strict';

  function initGifLogo() {
    var img = document.querySelector(
      '.site-header__logo-image img, .site-header__logowrapper img'
    );
    if (!img) return;

    /* Uniquement pour les GIF */
    var baseSrc = img.getAttribute('src') || '';
    if (!/\.gif(\?|$)/i.test(baseSrc)) return;

    /* Retire le cache-buster éventuel pour avoir une base propre */
    baseSrc = baseSrc.replace(/[?&]_adda=\d+/, '');

    var trigger = img.closest(
      '.site-header__logowrapper, .site-header__wrapper__center'
    ) || img.parentElement;

    var playing = false;

    trigger.addEventListener('mouseenter', function () {
      if (playing) return;
      playing = true;
      /* Forcer le rechargement du GIF depuis le début */
      img.src = baseSrc + (baseSrc.indexOf('?') !== -1 ? '&' : '?') +
                '_adda=' + Date.now();
    });

    /* Réarme dès que le GIF a fini (l'img reçoit "load" à chaque cycle) */
    img.addEventListener('load', function () {
      playing = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGifLogo);
  } else {
    initGifLogo();
  }
})();
